import React, {Component} from 'react';
import {Button, Modal, Space, App} from 'antd';
import axios from 'axios';

const DeleteEventModalWrapper = (props) => {
    const {message: messageApi} = App.useApp();
    return <DeleteEventModal {...props} messageApi={messageApi} />;
};

class DeleteEventModal extends Component {
    formRef = React.createRef();

    state = {
        loading: true,
    };

    componentDidMount() {
        this.setState({
            loading: false,
        });
    }

    confirm_delete() {
        this.setState({loading: true});

        axios
            .delete('/api/notification/delete/' + this.props.notification.id)
            .then((rsp) => {
                this.props.add_remove_notification(this.props.notification, 'remove');
                this.props.onCancel();
                this.props.messageApi.success('Tókst, áminningu hefur verið eytt!');
            })
            .catch((err) => {
                this.setState({loading: false});
                this.props.messageApi.error(err.response?.data?.detail || 'Úps, eitthvað fór úrskeiðis :(');
            });
    }

    render() {
        return (
            <Modal footer={null} open={this.props.visible} title='Alveg viss?' onCancel={this.props.onCancel}>
                <Space>
                    <Button
                        onClick={() => {
                            this.confirm_delete();
                        }}
                    >
                        Já, henda!
                    </Button>
                    <Button
                        onClick={() => {
                            this.props.onCancel();
                        }}
                    >
                        Hætta við
                    </Button>
                </Space>
            </Modal>
        );
    }
}

export default DeleteEventModalWrapper;
